import { NgModule }      from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { routing } from './home.routing.module';
import { MatDialogModule } from '@angular/material';

import { SharedModule } from '../shared/shared.module';

import * as View from './index.component';
import { AuthenticationComponent } from '../shared/common/authentication.component';
import { MaintenanceconfigService } from '../admin/index.service';
import { NgMarqueeModule } from 'ng-marquee';


@NgModule({
    imports: [
        ReactiveFormsModule,
        CommonModule,
        SharedModule,
        routing,
        MatDialogModule,
        NgMarqueeModule
    ],
    declarations: [
        View.IndexComponent
    ],
    providers: [
        MaintenanceconfigService
    ]
})
export class HomeModule { }


// WEBPACK FOOTER //
// D:/PhoenixScrum/Main/CitizenSevicesEx/CSClient/CSClient/client/app/home/home.module.ts